<template>
  <div class="review container">
    <h4>{{ selectedCatalog }}</h4>
    <!-- slides go here -->
    <b-card>
      <b-row v-if="this.reviewSelected.length">
        <b-col sm="11" md="12" class="my-1">
          <b-button variant="outline-secondary" @click="prevReviewSelected()"
            >Back</b-button
          >
          <b-button variant="outline-primary" @click="nextReviewSelected()"
            >Next</b-button
          >
        </b-col>
      </b-row>
      <div v-if="currentReviewSelected" class="currentReviewSelected">
        <b-row>
          <b-col class="col-sm-12 col-md-6 col-lg-6">
            <l-map
              ref="myMap"
              :center="getCenter()"
              :zoom="zoom"
              @update:center="centerUpdate"
              @update:zoom="zoomUpdate"
              @click="getLocation"
            >
              <l-tile-layer :url="url" :attribution="attribution" />
              <l-marker
                :options="{ draggable: true }"
                :lat-lng.sync="markers"
              />
            </l-map>
          </b-col>
          <b-col class="dataReview col-sm-12 col-md-6 col-lg-6">
            <!-- action -->
            <b-row>
              <b-col sm="11" md="12" class="my-1">
                <b-form-group
                  label="Action"
                  label-for="selectAction"
                  label-cols-sm="6"
                  label-cols-md="4"
                  label-cols-lg="3"
                  label-align-sm="left"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-select
                    id="selectAction"
                    :options="actionOptions"
                    :value="accuracyId"
                    size="sm"
                    @change="actionChange($event)"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <!-- address -->
            <b-row>
              <b-col sm="11" md="12" class="my-1">
                <b-form-group
                  label="Address"
                  label-for="addressArea"
                  label-cols-sm="6"
                  label-cols-md="4"
                  label-cols-lg="3"
                  label-align-sm="left"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-textarea
                    id="addressArea"
                    disabled
                    rows="3"
                    max-rows="6"
                    :value="currentReviewSelected['address']"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <!-- postcode -->
            <b-row>
              <b-col sm="11" md="12" class="my-1">
                <b-form-group
                  label="Postcode"
                  label-for="postcodeInput"
                  label-cols-sm="6"
                  label-cols-md="4"
                  label-cols-lg="3"
                  label-align-sm="left"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-input
                    id="postcodeInput"
                    :value="currentReviewSelected['postcode']"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <!-- brand -->
            <b-row>
              <b-col sm="11" md="12" class="my-1">
                <b-form-group
                  label="Brand"
                  label-for="brandInput"
                  label-cols-sm="6"
                  label-cols-md="4"
                  label-cols-lg="3"
                  label-align-sm="left"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-input
                    id="brandInput"
                    :value="currentReviewSelected['brand']"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <!-- gammaId -->
            <b-row>
              <b-col sm="11" md="12" class="my-1">
                <b-form-group
                  label="Gamma Id"
                  label-for="gammaIdInput"
                  label-cols-sm="6"
                  label-cols-md="4"
                  label-cols-lg="3"
                  label-align-sm="left"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-input
                    id="gammaIdInput"
                    :value="currentReviewSelected['gamma_id']"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <!-- coordinates -->
            <b-row>
              <b-col sm="11" md="12" class="my-1">
                <b-form-group
                  label="Coordinates(Y, X)"
                  label-for="coordInput"
                  label-cols-sm="6"
                  label-cols-md="4"
                  label-cols-lg="3"
                  label-align-sm="left"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-input
                    id="coordInput"
                    :value="getGeom()"
                    @change="updateMarker"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <!-- submit data -->
            <b-row>
              <b-col sm="11" md="12" class="my-1">
                <b-button id="submitData" variant="primary" @click="updateDB"
                  >Update</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr />
      </div>
    </b-card>
    <b-alert
      :show="alertTime"
      dismissible
      fade
      :variant="alertVariant"
      @dismiss-count-down="alertTimeChanged"
      >{{ alertMessage }}
    </b-alert>
  </div>
</template>

<script>
import Vue from "vue";
import proj4 from "@/util/proj4-module";
import { latLng, Icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { mapState } from "pinia";
import { useReviewCatalog } from "@/store/reviewCatalog";

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-popup", LPopup);
Vue.component("l-tooltip", LTooltip);

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default Vue.extend({
  data: () => ({
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    center: null,
    currentcenter: latLng(53.27983586756578, -6.213194621186445),
    zoom: 15,
    currentZoom: 11.5,
    markers: latLng(53.27983586756578, -6.213194621186445),
    currentReviewSelected: {
      geom: {
        coordinates: null,
      },
    },
    dpRequest: {
      // default object for request, modifications made in sidebar
      // paging: { page: 5, size: 20 }
    },
    currentIndexSelected: 0,
    actionOptions: ["Pass", "Fail", "Unknown"],
    accuracyId: null,
    locValStatus: null,
    currentResponseStatus: null,
    proj2157: proj4("EPSG:2157"),
    proj4326: proj4("EPSG:4326"),
    alertVariant: "success",
    alertTime: 0,
    alertMessage: null,
    dismissSecs: 4,
  }),
  computed: {
    ...mapState(useReviewCatalog, [
      "reviewSelected",
      "selectedCatalog",
      "reviewStatus",
      "selectedDataCatId",
      "updateLogData",
      "updateStatus",
    ]),
    updateLogData: {
      get() {
        return useReviewCatalog().updateLogData;
      },
    },
  },
  mounted() {
    if (!this.reviewSelected.length) {
      this.$router.push("location-validator");
    } else {
      this.$nextTick(function () {
        this.markers = this.currentcenter;
        this.center = this.currentcenter;
      });
    }
  },
  methods: {
    alertTimeChanged(alertTime) {
      this.alertTime = alertTime;
    },
    setCurrentReviewSelect(index) {
      this.accuracyId = null;
      this.currentReviewSelected = this.reviewSelected[index];
      this.currentIndexSelected = index;
      this.updateMarker("" + this.getCurrentLatLng());
    },
    getCurrentReviewSelected() {
      if (this.currentReviewSelected?.geom.coordinates == null) {
        this.setCurrentReviewSelect(0);
      }
      return this.currentReviewSelected.geom.coordinates;
    },
    getCurrentLatLng() {
      const x = proj4(
        this.proj2157,
        this.proj4326,
        this.getCurrentReviewSelected()
      )[0];
      const y = proj4(
        this.proj2157,
        this.proj4326,
        this.getCurrentReviewSelected()
      )[1];
      return latLng(y, x);
    },
    getGeom() {
      this.centerUpdate(this.getCurrentLatLng());
      return "" + this.getCurrentLatLng();
    },
    setGeom(geom) {
      this.currentReviewSelected.geom.coordinates = [
        proj4(this.proj4326, this.proj2157, [
          geom.latlng.lng,
          geom.latlng.lat,
        ])[0],
        proj4(this.proj4326, this.proj2157, [
          geom.latlng.lng,
          geom.latlng.lat,
        ])[1],
      ];
    },
    setCurrentMarkers() {
      this.markers = this.getCurrentLatLng();
    },
    updateMarker(ob) {
      const str = ob.substring(7, ob.length - 1).split(",");
      this.center = latLng(str[0], str[1]);
      this.markers = latLng(str[0], str[1]);
      this.centerUpdate(latLng(str[0], str[1]));
      this.setGeom({
        latlng: { lat: parseFloat(str[0]), lng: parseFloat(str[1]) },
      });
    },
    getCenter() {
      return this.getCurrentLatLng();
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentcenter = center;
    },
    getLocation(event) {
      this.setGeom(event);
      this.markers = event.latlng;
      this.centerUpdate(event.latlng);
    },
    getActionOptions() {
      return this.accuracyId;
    },
    actionChange(action) {
      this.accuracyId = action;
      this.updateLocValStatus(action);
      if (action === "Pass") {
        this.currentReviewSelected["accuracy_id"] = 7;
      } else if (action === "Fail" || action === "Unknown") {
        this.currentReviewSelected["accuracy_id"] = 3;
      }
    },
    updateLocValStatus(status) {
      if (status === "Pass") {
        this.locValStatus = 1;
      } else if (status === "Fail") {
        this.locValStatus = 2;
      } else if (status === "Unknown") {
        this.locValStatus = 7;
      }
    },
    prevReviewSelected() {
      if (this.currentIndexSelected !== 0) {
        this.setCurrentReviewSelect(this.currentIndexSelected - 1);
      }
    },
    nextReviewSelected() {
      if (this.currentIndexSelected + 1 < this.reviewSelected.length) {
        this.setCurrentReviewSelect(this.currentIndexSelected + 1);
      }
    },
    removeCurrentReviewSelected() {
      if (this.reviewSelected.length > 1) {
        // check for the last item in the array
        if (this.currentIndexSelected === this.reviewSelected.length - 1) {
          this.prevReviewSelected();
          this.$delete(this.reviewSelected, this.currentIndexSelected + 1);
        } else {
          this.nextReviewSelected();
          this.$delete(this.reviewSelected, this.currentIndexSelected - 1);
          this.currentIndexSelected = this.currentIndexSelected - 1;
        }
      }
    },
    async updateDB() {
      if (this.accuracyId == null) {
        alert("Please select the Action!");
      } else {
        const postResponse = await useReviewCatalog().updateLocation({
          catalogUri: this.selectedCatalog,
          request: {
            columnUpdates: [
              {
                column: {
                  columnName: "accuracy_id",
                },
                value: this.currentReviewSelected["accuracy_id"],
              },
              {
                column: {
                  columnName: "geom",
                },
                value: {
                  type: "Point",
                  coordinates: this.currentReviewSelected.geom.coordinates,
                },
              },
            ],
            filter: [
              {
                fieldName: "gamma_id",
                filterOperator: 0,
                conditionOperator: 0,
                value: this.currentReviewSelected["gamma_id"],
              },
            ],
          },
        });
        if (postResponse) {
          if (postResponse === 200) {
            await this.getUpdateLogData();
            await this.updateLocValReviewStatus();
            await this.removeCurrentReviewSelected();
          } else
            this.showAlert(
              4,
              "danger",
              "Something is wrong! Status code " + postResponse
            );
        } else
          this.showAlert(4, "danger", "Something is wrong! Empty response!");
      }
    },
    async getUpdateLogData() {
      this.dpRequest.filter = [
        {
          fieldName: "data_cat_id",
          filterOperator: 0,
          value: this.selectedDataCatId,
          conditionOperator: 0,
        },
        {
          fieldName: "update_status_id",
          filterOperator: 6,
          value: 1,
          conditionOperator: 0,
        },
      ];
      this.dpRequest.orderBys = [
        { columnName: "update_log_id", keyword: "desc" },
      ];
      await useReviewCatalog().getUpdateLogData({
        updateLogUri: "/data_mgmt/all/System/update_log",
        request: this.dpRequest,
      });
    },
    async updateLocValReviewStatus() {
      const response = await useReviewCatalog().updateLocValReviewStatus({
        locValReviewUri: "/data_mgmt/all/System/loc_validator_review_log",
        request: {
          columnInserts: [
            {
              column: {
                columnName: "last_update_log_id",
              },
              value: this.updateLogData.rows[0][0],
            },
            {
              column: {
                columnName: "gamma_id",
              },
              value: this.currentReviewSelected["gamma_id"],
            },
            {
              column: {
                columnName: "loc_val_result_type_id",
              },
              value: this.locValStatus,
            },
          ],
        },
      });
      if (response) {
        if (response === 200) {
          this.showAlert(this.dismissSecs, "success", "Successfully updated!");
        } else {
          this.showAlert(
            this.dismissSecs,
            "danger",
            "Something is wrong! Status code " + response
          );
        }
      } else {
        this.showAlert(
          this.dismissSecs,
          "danger",
          "Something is wrong! Empty response!"
        );
      }
    },
    showAlert(time, variant, msg) {
      this.alertTime = time;
      this.alertVariant = variant;
      this.alertMessage = msg;
    },
  },
});
</script>

<style scoped>
.alert {
  position: fixed;
  top: 85px;
  right: 40px;
  max-width: 35vw;
  z-index: 1;
}
.review {
  padding: 100px 15px 15px 50px !important;
}
img {
  width: 100%;
  min-width: 200px;
  max-height: 30rem;
}
label {
  max-width: 75px !important;
}
button {
  margin: 0px 15px 5px 0px;
}
.dataReview {
  min-width: 300px;
}
#submitData {
  width: 100%;
  margin-top: 20px;
}
</style>
